import { useNavigate } from "react-router-dom";
import styles from "./AboutPage.module.css";

const SparkIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v3M12 18v3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M3 12h3M18 12h3M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const BrainIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 4a3 3 0 0 0-3 3v11a3 3 0 0 0 6 0V7a3 3 0 0 0-3-3z"/>
    <path d="M9 8a2 2 0 0 1-2-2 3 3 0 0 1 5-2M15 8a2 2 0 0 0 2-2 3 3 0 0 0-5-2"/>
    <path d="M9 14a2 2 0 0 0-4 0 3 3 0 0 0 4 3M15 14a2 2 0 0 1 4 0 3 3 0 0 1-4 3"/>
  </svg>
);

const UsersIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const CompassIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
  </svg>
);

const cases = [
  {
    Icon: SparkIcon,
    headline: "Игры, которые меняют",
    sub: "трансформационные, психологические, аффирмационные",
    body: "«Лила», «Генезис», «Трансформация», расстановки, МАК-карты. Не развлечение — работа с собой в кругу таких же ищущих.",
    tag: "для души",
  },
  {
    Icon: BrainIcon,
    headline: "Мафия и настолки",
    sub: "живое общение, эмоции, азарт",
    body: "Мафия по вечерам, квизы по четвергам, настолки по выходным. Клубы, ведущие, атмосфера — всё что оживляет неделю.",
    tag: "для мозга",
  },
  {
    Icon: UsersIcon,
    headline: "Свои люди",
    sub: "которых ты видишь каждую неделю",
    body: "Не разовое событие — а среда, где через месяц ты уже знаешь по именам половину зала. Ходишь регулярно — становишься своим.",
    tag: "круг общения",
  },
  {
    Icon: CompassIcon,
    headline: "За 30 секунд",
    sub: "хватит скроллить час в поисках",
    body: "Все игры, психопрактики, мафия и квизы твоего города — в одном фильтре. Открыл, выбрал сегодня, идёшь.",
    tag: "экономия времени",
  },
];

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <p className={styles.eyebrow}>Tribe — не просто афиша</p>
        <h1 className={styles.heroTitle}>
          Не просто провести вечер.
          <br />
          <span className={styles.gradient}>Прожить его.</span>
        </h1>
        <p className={styles.heroSub}>
          Все игры, которые меняют — в одном месте. Трансформационные, психологические,
          мафия, настолки — рядом с тобой.
        </p>
      </section>

      <div className={styles.divider} />

      <section className={styles.cases}>
        <p className={styles.sectionLabel}>что тут можно найти</p>
        <div className={styles.grid}>
          {cases.map((c) => (
            <div key={c.headline} className={styles.card}>
              <span className={styles.icon}><c.Icon /></span>
              <div className={styles.cardTag}>{c.tag}</div>
              <h2 className={styles.cardTitle}>{c.headline}</h2>
              <p className={styles.cardSub}>{c.sub}</p>
              <p className={styles.cardBody}>{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <div className={styles.divider} />

      <section className={styles.manifesto}>
        <p className={styles.sectionLabel}>почему tribe</p>
        <blockquote className={styles.quote}>
          Устал скроллить час в поисках куда пойти?
          <br />
          Мы показываем что происходит рядом — и людей,
          <br />
          с которыми это интересно делать.
          <br />
          <span className={styles.gradient}>Найди своё племя.</span>
        </blockquote>
      </section>

      <section className={styles.cta}>
        <button className={styles.ctaBtn} onClick={() => navigate("/")}>
          Что сегодня рядом →
        </button>
      </section>
    </div>
  );
}
